import type { FC } from 'react';

import { BANNER_TAG, type HotColdBannerTag } from 'features/games/constants/gameBanners';
import styles from './StatisticRtpGameBanner.module.css';

const StatisticRtpGameBanner: FC<{
  gameStatisticRtp: number | null | undefined;
  hotOrCold: HotColdBannerTag;
}> = ({ gameStatisticRtp, hotOrCold }) => {

  if (gameStatisticRtp == null) return null;

  return (
    <div
      className={`${styles.badge} ${hotOrCold === BANNER_TAG.COLD ? styles.coldTheme : ''}`}
    >{`${gameStatisticRtp.toFixed(2)}%`}</div>
  );
};

export default StatisticRtpGameBanner;
